import { css } from '@emotion/core';
import { media, shadow, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  shadows = tokens.shadows;
var _ref = {
  name: "16r9pk3",
  styles: "max-width:400px;"
};
var _ref2 = {
  name: "1l0z8uk",
  styles: "flex-direction:row;"
};
var _ref3 = {
  name: "1c7e928",
  styles: "width:50%;flex-shrink:1;"
};
var _ref4 = {
  name: "493ori",
  styles: "margin-top:25px;"
};
var _ref5 = {
  name: "uyj313",
  styles: "width:50%;justify-content:center;gap:16px;align-items:center;"
};
var _ref6 = {
  name: "12lpig0",
  styles: "display:flex;flex-direction:column;text-align:center;width:100px;"
};
var _ref7 = {
  name: "a5juie",
  styles: "font-size:18px;line-height:18px;"
};
var _ref8 = {
  name: "1bx8ft2",
  styles: "display:flex;padding:14px 18px;justify-content:space-between;text-decoration:none;&:before{position:absolute;top:0;right:0;left:0;bottom:0;z-index:2;content:'';}"
};
export default (layout => {
  var isHorizontal = layout === 'horizontal';
  var nearbySales = /*#__PURE__*/css("display:flex;flex-direction:column;border:1px solid ", colors.neutral.trim.default, ";border-radius:3px;color:", colors.neutral.heavy.default, ";position:relative;&:hover{box-shadow:", shadow(shadows.elevation4), ";cursor:pointer;}", !isHorizontal && _ref);
  var body = /*#__PURE__*/css("display:flex;flex-direction:column;justify-content:space-between;margin:16px 16px 0;", isHorizontal && _ref2);
  var summary = /*#__PURE__*/css("display:flex;flex-direction:column;", isHorizontal && _ref3);
  var heading = /*#__PURE__*/css(designTokenFonts.overline, " text-transform:uppercase;text-align:center;margin-bottom:12px;strong{", designTokenFonts.displayMedium, " color:", colors.interactive.base.default, ";}");
  var detail = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";", designTokenFonts.body, " text-align:center;strong{", designTokenFonts.bodyBold, "}");
  var bodySeparator = /*#__PURE__*/css("margin:20px 0;", isHorizontal && /*#__PURE__*/css("border-left:1px solid ", colors.neutral.trim.default, ";margin:0 16px;"));
  var separator = _ref4;
  var prices = /*#__PURE__*/css("display:flex;width:100%;justify-content:space-between;", isHorizontal && _ref5);
  var stat = _ref6;
  var statName = /*#__PURE__*/css(designTokenFonts.overline, " margin-bottom:12px;");
  var statValue = /*#__PURE__*/css(designTokenFonts.displayMedium, " text-transform:uppercase;", media('>=mobile'), "{font-size:28px;line-height:28px;}");
  var unit = _ref7;
  var medianValue = /*#__PURE__*/css(statValue, " color:", colors.interactive.base.default, ";", media('>=mobile'), "{font-size:32px;}");
  var link = _ref8;
  var linkText = /*#__PURE__*/css(designTokenFonts.bodyBold, " color:", colors.interactive.base.default, ";flex:auto;margin-left:10px;vertical-align:top;");
  var linkIcon = /*#__PURE__*/css("color:", colors.interactive.base.default, ";vertical-align:text-top;");
  return {
    nearbySales,
    body,
    summary,
    heading,
    detail,
    bodySeparator,
    separator,
    prices,
    stat,
    statName,
    statValue,
    unit,
    medianValue,
    link,
    linkText,
    linkIcon
  };
});